module.exports = __webpack_public_path__ + "static/media/X.5562901f.svg";